<template>
  <div>
    <b-table
     :show="items.length>0"
     :current-page="currentPage"
     :per-page="perPage"
     :busy.sync="loading"
     responsive="true"
     striped
     hover
     id="auftrag-table"
     :items="itemProvider"
     :fields="fields">
      <template v-slot:cell(created)="row">
      <router-link :to="`/auftrag/${row.item.id}`">
      {{row.item.created|formatDateOnly}}
      </router-link>
      </template>
      <template v-slot:cell(firmaName)="row">
      <router-link v-if="row.item.firmaId" :to="{ path: '/Benutzer/'+row.item.firmaId}">
      {{row.item.firmaName}}
      </router-link>
      <span  v-if="!row.item.firmaId" >{{row.item.firmaName}}</span>
      </template>
      <template v-slot:cell(gage)="row">
      <router-link :to="`/auftrag/${row.item.id}`">
      {{fmt(row.item.gage*row.item.tage+(row.item.technikMiete*row.item.tage))}}
      </router-link>
      </template>
    </b-table>
     <b-pagination v-if="rows>perPage" v-model="currentPage" :total-rows="rows"
      :per-page="perPage" aria-controls="auftrag-table"></b-pagination>
  </div>
</template>
<script>
import api from '@/api/workflow'

export default {
  name: 'CutterAuftragTable',
  props: ['user', 'editMode'],
  methods: {
    fmt (value) {
      return value.toLocaleString('de-DE', {style: 'currency', currency: 'EUR'})
    },
    async itemProvider (ctx) {
      try {
        const offset = (ctx.currentPage - 1) * ctx.perPage
        const pagedList = await api.cutterauftraege(this.$route.params.id, offset, ctx.perPage)
        if (pagedList) {
          this.rows = pagedList.size
          this.items = pagedList.items
          return pagedList.items
        }
        return []
      } catch (error) {
        console.log(error)
        return []
      }
    },
    async update () {
      this.$root.$emit('bv::refresh::table', 'auftrag-table')
    }
  },
  mounted () {
    this.update()
  },
  watch: {
    '$route.params': {
      handler (newValue) {
        this.update()
      }
    }
  },
  data () {
    return {
      rows: 0,
      currentPage: 1,
      perPage: 50,
      loading: false,
      items: [],
      fields: [{key: 'created', label: 'Datum'}, {key: 'firmaName', label: 'Kunde'}, {key: 'gage', label: 'Wert'}]
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/CutterAuftragTable.vue